<template>
  <path
    class="bottom"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.25 21H11V22C11 23.1046 11.8954 24 13 24H17V28.75C17 29.4404 17.5596 30 18.25 30H21.75C22.4404 30 23 29.4404 23 28.75V24H27C28.1046 24 29 23.1046 29 22V21H21.75H18.25Z"
    fill="currentColor"
  />
  <path
    class="top"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 10C11.8954 10 11 10.8954 11 12V19H29V12C29 10.8954 28.1046 10 27 10H26V14C26 14.5523 25.5523 15 25 15C24.4477 15 24 14.5523 24 14V10H21V14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14V10H16V14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14V10H13Z"
    fill="currentColor"
  />
</template>
